/**
 * Nome comercial de marca — protegido contra tradução automática do navegador
 * (translate="no" + class notranslate). Como a proteção fica na renderização,
 * marcas cadastradas no futuro são protegidas automaticamente.
 */
export const BrandName = ({ name, className = "" }) => (
  <span translate="no" className={`notranslate ${className}`.trim()}>{name}</span>
);
